import React, { useState } from 'react';
import { wrapper } from './InfoBox.css';
import { Col, Row } from '@design-system/components/grid/grid';
import { Typography } from '@design-system/components/typography/typography';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { useAutoAnimateSafe } from '@design-system/utils';

export const InfoBox = ({
  title,
  children,
  icon,
  collapsible = false,
  defaultOpen = true,
}: React.PropsWithChildren<{
  title: string;
  collapsible?: boolean;
  defaultOpen?: boolean;
  icon?: IconProp;
}>) => {
  const [ref] = useAutoAnimateSafe({ duration: 200 });

  const [isOpen, setIsOpen] = useState(defaultOpen);

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Col
      className={wrapper}
      ref={ref}
      onClick={collapsible ? toggleOpen : undefined}
    >
      <Row alignCenter spreadEvenly>
        <Row alignCenter>
          {icon && <FontAwesomeIcon icon={icon} />}
          <Typography>{title}</Typography>
        </Row>
        {collapsible && (
          <div style={{ cursor: 'pointer' }}>
            <FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} />
          </div>
        )}
      </Row>
      {(!collapsible || isOpen) && (
        <Row>
          <Typography variant="body" size="medium" fontWeight="normal">
            {children}
          </Typography>
        </Row>
      )}
    </Col>
  );
};
